
import React from 'react';
import { motion } from 'framer-motion';
import { ChevronUp } from 'lucide-react';

interface ScrollToTopButtonProps {
  visible: boolean;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({ visible }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      onClick={scrollToTop}
      className="fixed right-6 bottom-6 bg-gradient-to-r from-blue-500 to-sky-500 text-white p-3 rounded-full shadow-lg hover:from-blue-600 hover:to-sky-600 transition-all z-50"
    >
      <ChevronUp size={24} />
    </motion.button>
  );
};

export default ScrollToTopButton;
